import type { StaffRole } from '@/types';

export const ALL_STAFF_ROLES: StaffRole[] = [
  'owner',
  'manager',
  'receptionist',
  'therapist',
  'doctor',
  'nutritionist',
  'cashier',
  'storekeeper',
  'billing',
  'assistant',
];

/** Label keys in `labels.ts` — use `t(lang, staffRoleLabelKey(role))`. */
export const STAFF_ROLE_LABEL_KEY: Record<StaffRole, string> = {
  owner: 'roleOwner',
  manager: 'roleManager',
  receptionist: 'roleReceptionist',
  therapist: 'roleTherapist',
  doctor: 'roleDoctor',
  nutritionist: 'roleNutritionist',
  cashier: 'roleCashier',
  storekeeper: 'roleStorekeeper',
  billing: 'roleBilling',
  assistant: 'roleAssistant',
};

export function staffRoleLabelKey(role: StaffRole): string {
  return STAFF_ROLE_LABEL_KEY[role];
}

export function assignableRoles(callerIsOwner: boolean): StaffRole[] {
  if (callerIsOwner) return [...ALL_STAFF_ROLES];
  return ALL_STAFF_ROLES.filter((r) => r !== 'owner');
}
